import cookies from 'js-cookie';
import storage from 'good-storage';
var LoginStatusKey = 'Login-Status'; // 登录态 0未授权未登录 1授权未登录 2 登陆成功

var TokenKey = 'Access-Token'; // token

var UserInfoKey = 'User-Info'; // 用户信息 {} {...}
// 获取登录状态

export function loadLoginStatus() {
  return cookies.get(LoginStatusKey) || 0;
} // 保持登录状态

export function saveLoginStatus(status) {
  cookies.set(LoginStatusKey, status, {
    expires: 7
  });
  return status;
} // 删除登录状态

export function removeLoginStatus() {
  cookies.remove(LoginStatusKey);
  return '';
} // 获取token

export function loadToken() {
  return cookies.get(TokenKey) || '';
} // 保存token

export function saveToken(token) {
  cookies.set(TokenKey, token, {
    expires: 7
  });
  return token;
} // 删除token

export function removeToken() {
  cookies.remove(TokenKey);
  return '';
} // 获取用户信息

export function loadUserInfo() {
  return storage.get(UserInfoKey, {});
} // 保存用户信息

export function saveUserInfo(userInfo) {
  storage.set(UserInfoKey, userInfo);
  return userInfo;
} // 删除用户信息

export function removeUserInfo() {
  storage.remove(UserInfoKey);
  return {};
}